import AxiosConfiguration from '@/classes/AxiosConfiguration';

const ParameterApiUrl = 'parameter/';

export const FeatureToggleService = {
  async getFeatureToggle(featureToggleGroup: string): Promise<string> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      ParameterApiUrl, { params: { entityTypeId: 0, entityPk: 0, group: featureToggleGroup, code: 'FeatureToggle' } }
    );
    return response.data;
  }
};
